import { apiClient } from '../lib/api/client';

export interface DimensionScores {
    technical: number;
    communication_clarity: number;
    confidence: number;
    relevance: number;
    structure: number;
    conciseness: number;
    professionalism: number;
}

export interface PerformancePoint {
    interview_id: string;
    type?: 'video' | 'simulation';
    job_title: string;
    company: string;
    date: string;
    overall_score: number;
    dimensions: DimensionScores;
}

export interface PerformanceSummary {
    total_sessions: number;
    avg_score: number;
    improvement_pct: number | null;
    current_streak: number;
    best_dimension: string | null;
    weakest_dimension: string | null;
    sessions_this_week: number;
}

export interface PerformanceAnalytics {
    performance_over_time: PerformancePoint[];
    dimension_averages: DimensionScores & { overall: number };
    summary: PerformanceSummary;
}

export const DIM_LABELS: Record<keyof DimensionScores, string> = {
    technical:             'Technical',
    communication_clarity: 'Clarity',
    confidence:            'Confidence',
    relevance:             'Relevance',
    structure:             'Structure',
    conciseness:           'Conciseness',
    professionalism:       'Professionalism',
};

const CACHE_TTL = 60_000;
let _cache: { data: PerformanceAnalytics; at: number; days?: number } | null = null;

export const analyticsService = {
    async getPerformance(days?: number, force = false): Promise<PerformanceAnalytics> {
        if (!force && _cache && _cache.days === days && Date.now() - _cache.at < CACHE_TTL) {
            return _cache.data;
        }
        const path = days
            ? `/api/users/me/analytics/performance?days=${days}`
            : '/api/users/me/analytics/performance';
        const data = await apiClient.get<PerformanceAnalytics>(path);
        _cache = { data, at: Date.now(), days };
        return data;
    },

    invalidate() { _cache = null; },
};
